(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-mounting"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMount(root) {
      if (root.dataset.mountReady) return;
      var track = root.querySelector('[data-pdp-mount-track]');
      var dotsWrap = root.querySelector('[data-pdp-mount-dots]');
      if (!track || !dotsWrap) return;
      root.dataset.mountReady = '1';

      var prev = root.querySelector('[data-pdp-mount-prev]');
      var next = root.querySelector('[data-pdp-mount-next]');
      var slides = track.querySelectorAll('.pdp-mount__slide');
      if (slides.length <= 1) {
        var nav = root.querySelector('.pdp-mount__nav');
        if (nav) nav.style.display = 'none';
        return;
      }

      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'pdp-mount__dot';
        d.dataset.i = i;
        d.setAttribute('aria-label', 'Step ' + (i + 1));
        dotsWrap.appendChild(d);
      }
      var dots = dotsWrap.querySelectorAll('.pdp-mount__dot');

      function idx() {
        return Math.round(track.scrollLeft / (track.clientWidth || 1));
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        track.scrollTo({ left: i * track.clientWidth, behavior: behavior });
      }
      function sync() {
        var c = idx();
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('pdp-mount__dot--active', j === c);
        if (prev) prev.disabled = c <= 0;
        if (next) next.disabled = c >= slides.length - 1;
      }

      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      dotsWrap.addEventListener('click', function (e) {
        var t = e.target.closest('.pdp-mount__dot');
        if (t) go(parseInt(t.dataset.i, 10) || 0);
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    function initAll() {
      var nodes = document.querySelectorAll('[data-pdp-mount]');
      for (var i = 0; i < nodes.length; i++) initMount(nodes[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
